import script from "./ModalCropImage.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCropImage.vue?vue&type=script&setup=true&lang=js"

import "./ModalCropImage.vue?vue&type=style&index=0&id=3c77f7bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c77f7bc"]])

export default __exports__